<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">

      <div class="card">
        <div class="card-body">
          <PageHeader :title="title" :items="items" />
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Expediente</label>
              <v-select
                  :options="expedientes"
                  label="obra_expediente"
                  :reduce="desc=>desc.expediente_id"
                  v-model="expediente_id"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-5">
              <label>Reporte</label>
              <v-select
                  :options="reportes"
                  label="descripcion"
                  v-model="reporte"
              />
            </div>
            <div class="form-group col-md-3">
              <button class="btn btn-primary mt-4 mr-2" v-on:click="cargarReporte">Ver</button>
              <button class="btn btn-primary mt-4" v-on:click="onBtnExport">Exportar CSV</button>
              <!--<button class="btn btn-primary mt-4 ml-1" v-on:click="onBtnExport">Descargar CSV</button>-->
            </div>

          </div>

          <div class="form-row">
            <div class="form-group col-md-4" v-show="reporte.fecha_mostrar">
              <label>Rango de Fechas</label>
              <VueCtkDateTimePicker
                  v-model="fecha"
                  :locale="'es'"
                  :input-size="'sm'"
                  :format="'YYYY-MM-DD'"
                  :formatted="'YYYY-MM-DD'"
                  :range="true"

                  :only-date="true"
                  :no-header="true"
                  :custom-shortcuts="custom"
              />
            </div>
            <div class="form-group col-md-4" v-show="reporte.fecha_mes_mostrar">
              <label>Mes</label>
              <month-picker-input   @change="cambiarMes" :no-default="true" style="z-index:1"></month-picker-input>
            </div>

          </div>

          <div class="row">
            <ag-grid-vue
                style="width: 100%; height: 400px"
                class="ag-theme-balham"
                :columnDefs="columnDefs"
                :rowData="rowData"
                :gridOptions="gridOptions"
                @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </div>
          <div class="row">
            <div class="col-md-12 text-right mt-4">
              <h4>Total:S/ {{total}}</h4>
            </div>
          </div>

        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import appConfig from "@/app.config.json";
import PageHeader from "@/components/page-header.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Reportes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Reportes finanzas",
      items: [
        {
          text: "Avance",
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      lista:[],
      reporte: {
        fecha_mostrar:false,
        fecha_rango_mostrar:false,
        fecha_mes_mostrar:false
      },
      reportes:[],
      fecha_mes:{
        mes:0,
        anio:0
      },
      //



      fecha:null,
      fecha_mostrar:null,
      expediente_id:null,
      gridApi: null,
      columnApi: null,
      columnDefs:[],
      rowData:[],
      gridOptions: {
        //floatingFiltersHeight:50,
        defaultColDef: {
          sortable: true,
          resizable: true,
          floatingFilter:true
        },

      },
      total:0,
      expedientes:[],
      custom:[
        { key: 'thisWeek', label: 'Esta semana', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Ultima semana', value: '-isoWeek' },
        { key: 'last7Days', label: 'Ultimos 7 dias', value: 7 },
        { key: 'last30Days', label: 'Ultimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mes', value: 'month' },
        { key: 'lastMonth', label: 'Ultimo mes', value: '-month' },
        { key: 'thisYear', label: 'Este año', value: 'year' },
        { key: 'lastYear', label: 'Ultimo año', value: '-year' }
      ]
    };
  },
  beforeMount() {

    this.columnDefs= [

    ];
    this.rowData= [

    ];

  },
  methods: {
    cambiarMes(date){
      this.fecha_mes.mes=date.monthIndex;
      this.fecha_mes.anio=date.year;
    },
    onBtnExport() {
      this.gridApi.exportDataAsCsv();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

    },
    cargarReporte()
    {

      if(this.reporte.fecha_mes_mostrar){
        if(this.fecha_mes.mes==0){
          this.$swal("error", "Seleccione un mes", "error");
          return;
        }
      }
      this.isLoading = true;
      this.rowData=[];
      this.axios.get(
          process.env.VUE_APP_BACKEND + "/api/finanzas/reportes/varios",
          {
            params:
                {
                  tipo_id:this.reporte.id,
                  fecha:this.fecha,
                  expediente_id:this.expediente_id,
                  fecha_mes:this.fecha_mes
                }
          }
      )
        .then((response)=> {
          this.columnDefs=response.data.columnas;
          this.rowData=response.data.datos;
          this.total=response.data.total;
        })
        .catch(() => {
          this.$swal("error", "Error", "error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    cargarExpedientes(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
          .then((response)=>{
            this.expedientes=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los expedientes",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    cargarReportes(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/finanzas/reportes")
          .then((response)=>{
            this.reportes=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los reportes",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
  },
  mounted() {
    this.cargarExpedientes();
    this.cargarReportes();
    //var date= new Date();
    //this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
  }
}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
